import type { Dispatch, SetStateAction } from "react";
import { IoIosClose } from "react-icons/io";
import { TablaClientes } from "../../tablas/TablaClientes/TablaClientes";
import type { TablaClienteItem } from "../../tablas/TablaClientes/types";
import { CrearClienteExistenteModal } from "../CrearClienteExistenteModal/CrearClienteExistenteModal";
import type { UsuarioRuta as CrearClienteUsuarioRuta } from "../CrearClienteExistenteModal/types";
import type { VerTablaClientesModalProps } from "./types";
import { useVerTablaClientesModal } from "./verTablaClientesModalHooks";

const noopBoolean: Dispatch<SetStateAction<boolean>> = () => {};

export const VerTablaClientesModal = (props: VerTablaClientesModalProps) => {
  const {
    formatearNumeros,
    handleClose,
    handleSearchTermChange,
    isModalCreateClienteExistente,
    searchTerm,
    searchTermExis,
    setIsModalCreateClienteExistente,
    setSearchTermExis,
    sumaPagosDiarios,
  } = useVerTablaClientesModal(props);

  return (
    <>
      {isModalCreateClienteExistente ? (
        <CrearClienteExistenteModal
          searchTermExis={searchTermExis}
          setIsModalCreateClienteExistente={setIsModalCreateClienteExistente}
          setSearchTermExis={setSearchTermExis}
          setUsuarioRuta={
            props.setSelectedRuta as Dispatch<SetStateAction<CrearClienteUsuarioRuta | null>>
          }
          usuarioRuta={props.selectedRuta as CrearClienteUsuarioRuta}
        />
      ) : null}

      <div className="w-full min-h-screen h-screen z-30 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
        <div className="bg-gray-200 w-[400px] md:w-full p-4 md:h-full rounded-md relative max-h-[90%] overflow-y-auto">
          <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
            <IoIosClose size={40} onClick={handleClose} />
          </div>

          <h2 className="font-bold text-lg">Clientes de ruta {props.selectedRuta.nombreRuta}</h2>

          <div className="mt-2">
            <div className="flex items-center">
              <div className="w-[20px] h-[20px] bg-red-500 mr-1 border border-black"></div>
              <span>Clientes vencidos o +8 dias sin pagar</span>
            </div>
            <div className="flex items-center">
              <div className="w-[20px] h-[20px] bg-yellow-500 mr-1 border border-black"></div>
              <span>7 dias sin pagar</span>
            </div>
            <div className="flex items-center">
              <div className="w-[20px] h-[20px] bg-green-500 mr-1 border border-black"></div>
              <span>2 a 6 dias sin pagar</span>
            </div>
            <div className="flex w-fit items-center mt-3">
              <span className="text-xs md:text-sm mr-1 md:font-semibold font-bold uppercase">
                cuotas por cobrar:
              </span>
              <span className="font-bold ">R${formatearNumeros(sumaPagosDiarios)}</span>
            </div>
          </div>

          <input
            type="text"
            placeholder="Buscar Cliente"
            className=" px-1 py-1 rounded-md shadow-lg mt-1"
            value={searchTerm}
            onChange={(event) => handleSearchTermChange(event.target.value)}
          />

          <div className="w-full overflow-x-auto py-2">
            <TablaClientes
              datos={(props.clientes ?? []) as TablaClienteItem[]}
              isEditIndex={false}
              searchTerm={searchTerm}
              setIsModalCreateClienteExistente={setIsModalCreateClienteExistente}
              setSearchTermExis={setSearchTermExis}
              setUsuarioRuta={props.setSelectedRuta}
              setisEditIndex={noopBoolean}
              usuarioRuta={props.selectedRuta}
            />
          </div>
        </div>
      </div>
    </>
  );
};
